import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { useDocumentTitle } from '~/hooks';
import { Header, Page } from '../components';
import EntityDetail from './EntityDetail';
import EntityList from './EntityList';

export default function EntityReplay() {
  useDocumentTitle('Entity Replay - Admin');

  const { path } = useRouteMatch();

  return (
    <Page>
      <Header />
      <Switch>
        <Route exact path={path}>
          <EntityList />
        </Route>
        <Route path={`${path}/:entity/:entityId`}>
          <EntityDetail />
        </Route>
      </Switch>
    </Page>
  );
}
